import classnames from 'classnames';

import style from './SubBlockItem.module.scss';

export interface SubBlockItemProps {}

interface Props extends SubBlockItemProps {
    title: string;
    isSelected: boolean;
    onClick(): void;
}

export function SubBlockItem({ title, isSelected, onClick }: Props) {
    return (
        <div
            className={classnames([style.root, isSelected && style.selected])}
            onClick={isSelected ? undefined : onClick}
        >
            {title}
        </div>
    );
}
